/**
 * Inline style for a table cell: padding, the column's size, and whatever the column's `meta.getStyleObj` adds.
 *
 * `meta` is free-form and may carry other keys without a `getStyleObj` (export headers do), so the function is
 * called only when it exists. Calling `meta?.getStyleObj(...)` unguarded threw as soon as a column had a `meta`
 * without one, and blanked the whole page (ESG-4029).
 *
 * Shared by DataTable and DataTableV2; standalone so vitest can import it.
 */
export function cellStyle(cell) {
  const style = { paddingInline: "var(--chakra-space-4)" };
  const size = cell.column.getSize();
  if (size) {
    style.minWidth = size;
    style.maxWidth = size;
  }
  const columnStyle = cell.column.columnDef.meta?.getStyleObj?.(cell.getValue(), cell);
  return typeof columnStyle === "undefined" ? style : { ...style, ...columnStyle };
}
